// Per-tenant feature gates (Stuart ruling, 2026-08-26, verbatim: "Silos as a
// form of warehouse should be able to be configured on or off, with the
// default being off because we don't have any silos for Howick. If at all,
// silos should just be a type of warehouse."). Every gating surface (nav,
// route guards, task buttons, reports, dashboard tiles, help mapping) reads
// off this one hook rather than reaching into `useAuth()` directly, so the
// "what counts as a gated feature" list has exactly one place to grow.
import { useAuth } from '../auth/AuthContext';

export interface TenantFeatures {
  silosEnabled: boolean;
}

/** Reads the ACTIVE tenant's settings snapshot (`TenantMembership.settings`,
 * sourced from `GET /me` — see AuthContext.tsx/services/api/src/me.ts).
 * `undefined`/`false`/no active tenant yet all read as OFF, which is the
 * correct default (absent = off) and also the safe choice while auth is still
 * resolving. */
export function useTenantFeatures(): TenantFeatures {
  const { activeTenant } = useAuth();
  return { silosEnabled: activeTenant?.settings?.silosEnabled === true };
}
